import {
  Avatar,
  Box,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Rating from "@mui/material/Rating";
import CustomButton from "../../common/Button/CustomButton";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import ReviewsAPI from "../../../api/firebase/ReviewsAPI";
import UserProfileContext from "../../../context/userProfile/UserProfileContext";
import ProductsAPI from "../../../api/firebase/ProductsAPI";
import Loader from "../../loader/Loader";
import UserDataAPI from "../../../api/firebase/UserDataAPI";
import LoginPage from "../../../pages/authentication/login";
import AllProductContext from "../../../context/allProducts/AllProductsContext";
import AllReviewsContext from "../../../context/allReviews/AllReviewsContext";

const AddReview = ({
  product,
  reviewData = {
    headline: "",
    detail: "",
    rating: 0,
  },
  handleClose,
}) => {
  const [ratingValue, setRatingValue] = React.useState(0);
  const [hoverRating, setHoverRating] = React.useState(-1);
  const [headlineText, setHeadlineText] = React.useState("");
  const [detailText, setDetailText] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorDescription, setErrorDescription] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [userProfile, setUserProfile] = React.useState({});
  const userProfileContext = React.useContext(UserProfileContext);
  const allProductsContext = React.useContext(AllProductContext);
  const allReviewsContext = React.useContext(AllReviewsContext);

  const reviewsAPI = new ReviewsAPI();
  const productsAPI = new ProductsAPI();
  const userDataApi = new UserDataAPI();

  React.useEffect(() => {
    if (reviewData !== null && reviewData.rating !== 0) {
      setHeadlineText(reviewData.headline);
      setDetailText(reviewData.detail);
      setRatingValue(reviewData.rating);
    }
  }, []);

  const generateRandomString = (length) => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
  React.useEffect(() => {
    const user = userProfileContext.state;
    // console.log("user:", user);

    if (user !== null) {
      setUserProfile({...user});
    } else {
      setUserProfile(null);
    }
  }, [userProfileContext.state]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    const data = new FormData(event.currentTarget);
    if (data.get("headline") === "" || data.get("headline").length < 2) {
      setError(true);
    } else if (
      data.get("description") === "" ||
      data.get("description").length < 2
    ) {
      setErrorDescription(true);
    } else {
      setError(false);
      setErrorDescription(false);
      if (ratingValue > 0) {
        const reviewId =
          reviewData !== null && reviewData.rating !== 0
            ? reviewData.id
            : generateRandomString(12);
        // Submit review
        const dataToSend = {
          id: reviewId,
          payload: {
            id: reviewId,
            product_id: product.id,
            user_id: userProfile.id,
            display_name: userProfile.displayName,
            email: userProfile.email,
            photoURL: userProfile.photoURL || null,
            headline: data.get("headline"),
            detail: data.get("description"),
            rating: ratingValue,
          },
        };
        // console.log("data to send:", dataToSend);
        setLoading(true);
        reviewsAPI
          .setReview(dataToSend)
          .then((res) => {
            if (res) {
              // console.log("setReview RES:", res);
              const oldReviewsForProd = product.reviews || [];
              const oldRatingsForProd = product.ratings || [];
              let payloadData = {};
              if (reviewData !== null && reviewData.rating !== 0) {
                const indexOfOldRating = oldRatingsForProd.indexOf(
                  reviewData.rating
                );
                oldRatingsForProd[indexOfOldRating] = ratingValue;
                payloadData = {
                  ratings: [...oldRatingsForProd],
                };
              } else {
                payloadData = {
                  reviews: [...oldReviewsForProd, reviewId],
                  ratings: [...oldRatingsForProd, ratingValue],
                };
              }

              const dataToProducts = {
                id: product.id,
                payload: payloadData,
              };
              // Add review to products table
              productsAPI
                .setProduct(dataToProducts, false)
                .then((res) => {
                  if (res) {
                    //Review Added Successfully, Update product context
                    const allProArr = allProductsContext.state;
                    const indexOfProduct = allProArr.findIndex(
                      (a) => a.id === product.id
                    );
                    allProArr[indexOfProduct] = {
                      ...product,
                      ...payloadData,
                    };
                    allProductsContext.setState([...allProArr]);
                    const oldReviewsByUser = userProfile.reviews || [];
                    const currentTime = new Date();
                    if (reviewData !== null && reviewData.rating !== 0) {
                      // Update all reviews context
                      const allReviewsArr = allReviewsContext.state;
                      const indexOfReview = allReviewsArr.findIndex(
                        (a) => a.id === reviewData.id
                      );

                      allReviewsArr[indexOfReview] = {
                        ...dataToSend.payload,
                        createdAt: currentTime,
                      };
                      allReviewsContext.setState([...allReviewsArr]);
                      setTimeout(() => {
                        setLoading(false);
                        handleClose();
                      }, 500);
                    } else {
                      const dataToUser = {
                        id: userProfile.id,
                        payload: {
                          reviews: [...oldReviewsByUser, reviewId],
                        },
                      };
                      userDataApi
                        .addUserData(dataToUser, false)
                        .then((res) => {
                          if (res) {
                            //Review Added Successfully, Update user profile context
                            userProfileContext.setState({
                              ...userProfileContext.state,
                              reviews: [...oldReviewsByUser, reviewId],
                            });

                            // Update all reviews context
                            allReviewsContext.setState([
                              ...allReviewsContext.state,
                              {...dataToSend.payload, createdAt: currentTime},
                            ]);
                            setTimeout(() => {
                              setLoading(false);
                              handleClose();
                            }, 500);
                          } else {
                            alert("Error Adding Review to users table");
                          }
                        })
                        .catch((ex) => {
                          setLoading(false);
                          console.error("EX:", ex);
                        });
                    }
                  } else {
                    handleClose();
                    alert("Error Adding Review to produts table");
                  }
                })
                .catch((ex) => {
                  setLoading(false);
                  console.error("EX:", ex);
                });
            } else {
              setLoading(false);
              alert("Error Adding Review to reviews table");
            }
          })
          .catch((ex) => {
            setLoading(false);
            console.error("EX:", ex);
          });
      }
    }
    // console.log({
    //   headline: data.get("headline"),
    //   description: data.get("description"),
    //   rating: ratingValue,
    // });
  };
  const handleHeadlineChange = (event) => {
    // console.log(event.target.value);
    setHeadlineText(event.target.value);
    if (event.target.value.length > 2) {
      setError(false);
    }
  };
  const ratingLabels = {
    1: "Poor",
    2: "Fair",
    3: "Average",
    4: "Good",
    5: "Excellent!",
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ position: "relative", px: { xs: 1, sm: 2 } }}>
      <CssBaseline />

      {handleClose && (
        <IconButton
          aria-label="close review dialog"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: "#64748b",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.06)",
              color: "#0f172a",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      )}

      {loading && <Loader fullHeight={false} />}
      {userProfile === null && <LoginPage redirect={false} />}
      {userProfile !== null && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Avatar
            sx={{
              m: 1,
              bgcolor: "#075e54",
              color: "#ffffff",
              width: 44,
              height: 44,
              boxShadow: "0 4px 12px rgba(7, 94, 84, 0.25)",
            }}
          >
            <CreateIcon />
          </Avatar>

          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 800, color: "#0f172a", mb: 0.5 }}
          >
            {reviewData !== null && reviewData.rating !== 0
              ? "Edit your review"
              : "Write a review"}
          </Typography>

          {/* Product context banner if product is provided */}
          {product && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                width: "100%",
                p: 1.25,
                mt: 1,
                mb: 1.5,
                borderRadius: "10px",
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
              }}
            >
              {product.images?.[0]?.url && (
                <img
                  src={product.images[0].url}
                  alt={product.title}
                  style={{
                    width: 44,
                    height: 44,
                    objectFit: "contain",
                    borderRadius: "6px",
                    backgroundColor: "#ffffff",
                    border: "1px solid #edf2f7",
                  }}
                />
              )}
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "#1e293b",
                  lineHeight: 1.3,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {product.title}
              </Typography>
            </Box>
          )}

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 1, width: "100%" }}
          >
            <Grid container spacing={2}>
              {/* Star Rating Selector */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                    borderRadius: "12px",
                    backgroundColor: "rgba(7, 94, 84, 0.03)",
                    border: "1px solid rgba(7, 94, 84, 0.12)",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, color: "#334155", mb: 1 }}
                  >
                    How would you rate this product?
                  </Typography>

                  <Rating
                    name="overall-rating"
                    size="large"
                    value={ratingValue}
                    onChange={(event, newValue) => {
                      setRatingValue(newValue);
                    }}
                    onChangeActive={(event, newHover) => {
                      setHoverRating(newHover);
                    }}
                    sx={{
                      color: "#faaf00",
                      fontSize: "2rem",
                      "& .MuiRating-iconFilled": {
                        filter: "drop-shadow(0 2px 4px rgba(250, 175, 0, 0.35))",
                      },
                    }}
                  />

                  {/* Rating Label Text Feedback */}
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 0.75,
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      color: "#075e54",
                      minHeight: "1.2rem",
                    }}
                  >
                    {(hoverRating !== -1 ? ratingLabels[hoverRating] : ratingLabels[ratingValue]) ||
                      "Tap stars to rate"}
                  </Typography>
                </Box>
              </Grid>

              {(ratingValue === 0 || ratingValue === null) && submitted && (
                <Grid item xs={12} sx={{ pt: "4px !important" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      textAlign: "center",
                      fontWeight: 600,
                      color: "#ef4444",
                    }}
                  >
                    Please select a rating from 1 to 5 stars
                  </Typography>
                </Grid>
              )}

              {/* Review Headline Input */}
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  value={headlineText}
                  type="text"
                  id="headline"
                  label="Headline"
                  name="headline"
                  placeholder="What's the most important thing to know?"
                  onChange={handleHeadlineChange}
                  error={error && submitted}
                  helperText={error && submitted ? "Please enter a headline" : ""}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />
              </Grid>

              {/* Review Detail Description Input */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  defaultValue={detailText}
                  name="description"
                  label="Detailed Review"
                  type="text"
                  id="description"
                  placeholder="What did you like or dislike about this product? How did it work for you?"
                  multiline
                  rows={4}
                  required
                  error={errorDescription && submitted}
                  helperText={
                    errorDescription && submitted
                      ? "Please write a brief description of your experience"
                      : ""
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />
              </Grid>
            </Grid>

            {/* Submit Button */}
            <CustomButton
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 1,
                py: 1.2,
                borderRadius: "10px",
                fontWeight: 700,
                fontSize: "1rem",
                backgroundColor: "#075e54",
                boxShadow: "0 4px 14px rgba(7, 94, 84, 0.25)",
                "&:hover": {
                  backgroundColor: "#064e46",
                },
              }}
            >
              {reviewData !== null && reviewData.rating !== 0
                ? "Update Review"
                : "Submit Review"}
            </CustomButton>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default AddReview;
